import {useFeatureFlag} from "@mytour/platform";
import {CompanyTypeArray, RequiredApeCodeSchema} from "@mytour/shared";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";
import {Step1AutofillForm} from "./Step1AutofillForm";
import {Step1ManualForm} from "./Step1ManualForm";

export const step1Schema = z
  .object({
    company: z.string().trim().min(3, {message: "Obligatoire"}),
    siret: z.string().trim().min(1, "Champ obligatoire"),
    apeCode: RequiredApeCodeSchema,
    apeLabel: z.string().trim().min(3, {message: "Obligatoire"}),
    companyType: z.enum(CompanyTypeArray),
    companyCapital: z.number().optional(),
  })
  .superRefine((data, ctx) => {
    if (!/^[0-9]{14}$/.test(data.siret)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["siret"],
        message: "Le SIRET doit contenir exactement 14 chiffres",
      });
    }
  });
export type Step1Form = z.infer<typeof step1Schema>;

export type Step1Props = {
  hookForm: UseFormReturn<Step1Form>;
  disabled: boolean;
};

/**
 * Onboarding identity step. The `siret-autofill` feature flag selects the
 * variant — and lives ONLY here. Each variant is a self-contained file, so
 * retiring the flag is deleting one file and collapsing this branch:
 *   - flag promoted → drop Step1ManualForm, keep Step1AutofillForm;
 *   - feature dropped → drop Step1AutofillForm, keep Step1ManualForm.
 */
export function Step1(props: Step1Props) {
  const siretAutofillEnabled = useFeatureFlag("siret-autofill");
  return siretAutofillEnabled ? <Step1AutofillForm {...props} /> : <Step1ManualForm {...props} />;
}
